function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "fixed-footer-arrow_svg__a",
  x: 0,
  y: 0,
  width: 64,
  height: 176,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.071
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#fixed-footer-arrow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51 88L5 167V9z",
  fill: "#f3f7fc"
}));

function SvgFixedFooterArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 176
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iMTc2IiB2aWV3Qm94PSIwIDAgNjQgMTc2Ij4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9ImEiIHg9IjAiIHk9IjAiIHdpZHRoPSI2NCIgaGVpZ2h0PSIxNzYiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxmZU9mZnNldCBkeD0iNCIgaW5wdXQ9IlNvdXJjZUFscGhhIi8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMiIHJlc3VsdD0iYiIvPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwLjA3MSIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgb3BlcmF0b3I9ImluIiBpbjI9ImIiLz4KICAgICAgICAgICAgPGZlQ29tcG9zaXRlIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCAwLCAwKSIgc3R5bGU9ImZpbHRlcjp1cmwoI2EpIj4KICAgICAgICA8cGF0aCBkPSJNNzksMGw3OSw0NkgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTEgOSkgcm90YXRlKDkwKSIgc3R5bGU9ImZpbGw6I2YzZjdmYyIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFixedFooterArrow as ReactComponent };